/* eslint-disable prettier/prettier */
/* eslint-disable security/detect-object-injection */
/* eslint-disable security/detect-non-literal-fs-filename */
import {
  FileModel,
  ModalContainerService,
  NotificationComponent,
} from "@aecom/core";
import { Component, HostListener, OnInit, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService, BBJFileListService } from "@bbj/components";
import BaseFunctionService from "@services/baseFunction.service";
import _ from "lodash";
import { Observable } from "rxjs";
import { IPRFIListItem, IUser } from "src/app/api-generated";
import { ComponentCanDeactivate } from "src/app/guards/pending-changes.guard";
import IRFIViewPrepare from "src/app/models/IRFIViewPrepaer";
import RFIReview from "src/app/models/rfiReview";
import LoadingService from "src/app/services/loading.service";
import LocalContractService from "src/app/services/local-contract.service";
import LocalUserService from "src/app/services/local-user.service";

@Component({
  selector: "app-review-rfi",
  templateUrl: "./review-rfi.component.html",
  styleUrls: ["./review-rfi.component.scss"],
  standalone: false
})
export default class ReviewRfiComponent
  implements OnInit, ComponentCanDeactivate
{
  router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  loadingService = inject(LoadingService);
  activemodal = inject(ModalContainerService);
  localContractService = inject(LocalContractService);
  private localUserService = inject(LocalUserService);
  private authService = inject(AuthService);
  bbjFileListService = inject(BBJFileListService);
  baseFunctionService = inject(BaseFunctionService);

  @HostListener("window:beforeunload")
  canDeactivate(): Observable<boolean> | boolean {
    return !this.hasChanges();
  }

  canIssueRFI = false;

  oldItem: RFIReview;

  newItem: RFIReview;

  entity: IPRFIListItem;

  users: IUser[];

  currentUser: string;

  defaultTab = "details";

  ngOnInit(): void {
    this.loadingService.start();
    this.users = this.localUserService.getItems();
    this.currentUser = this.authService.getUserId();
    const data: IRFIViewPrepare = this.activatedRoute.snapshot.data.RFIPrepare;
    this.entity = data.rfi;
    this.users = this.localUserService.getItems();
    this.defaultTab = this.entity.rfi_reviewer?.length > 0
      ? "responses"
      : "details";
    const myReviewer = this.entity.rfi_reviewer.find((r)=>{return r.ReviewerId === this.currentUser});
    this.oldItem = new RFIReview(myReviewer);
    this.baseFunctionService.setTempId(this.oldItem.Guid);
    this.baseFunctionService.initFileList();
    this.newItem = JSON.parse(JSON.stringify(this.oldItem));
    this.loadingService.stop();
  }

  hasChanges(): boolean {
    const old = JSON.stringify(this.oldItem);
    const currentRFI = JSON.stringify(this.newItem);
    // true means no changes
    return old !== currentRFI || this.bbjFileListService.areFilesChanged();
  }

  setResponse(e: string): void {
    this.newItem.Response = e;
  }

  setHasComments(e: boolean): void {
    this.newItem.hasComments = e;
  }

  IsValid(): boolean {
    if (this.newItem.hasComments &&
      (!this.newItem.Response ||
      this.newItem.Response.trim() === "" ||
      !this.IsInputValid() ||
      !this.bbjFileListService.isFileNameValid())
    ) {
      return false;
    }
    return true;
  }

  IsInputValid(): boolean {
    return !this.baseFunctionService.isInputInvalid(this.newItem.Response)
  }

  submitRFI(): void {
    this.canIssueRFI = true;
    // console.log("RFI", this.newItem);

    const validation = this.IsValid();
    // console.log(validation);
    if (this.bbjFileListService.hasFilesUploading()) {
      this.bbjFileListService.showFileProgressNotification();
    } else if (validation) {
      const modalInstance = this.activemodal.open(NotificationComponent);
      modalInstance.instance.theme = "light";
      modalInstance.instance.title = "Submit RFI Response?";
      modalInstance.instance.body =
        "Your RFI response will be sent to the Coordinator.";

      modalInstance.result.then((result) => {
        if (result === 1) {
          this.newItem.IsDraft = false;
          this.baseFunctionService.reviewerSubmit(this.newItem);
        }
      });
    }
  }

  saveDraft(): void {
    if (!this.hasChanges() || !this.bbjFileListService.isFileNameValid() || (this.newItem.hasComments && !this.IsInputValid())) return;
    
    if (this.bbjFileListService.hasFilesUploading()) {
      this.bbjFileListService.showFileProgressNotification();
    } else {
      const modalInstance = this.activemodal.open(NotificationComponent);
      modalInstance.instance.theme = "light";
      modalInstance.instance.title = "Save as Draft?";
      modalInstance.instance.body = "Your RFI will save as draft.";
      modalInstance.result.then((result) => {
        if (result === 1) {
          this.newItem.IsDraft = true;
          this.baseFunctionService.reviewerSubmit(this.newItem);
        }
      });
    }
  }

  importFile(e: FileModel[]): void {
    this.baseFunctionService.importFile(e);
  }

  deleteFile(e: FileModel): void {
    this.baseFunctionService.deleteFile(e);
  }

  back(): void {
    if (this.hasChanges()) {
      this.baseFunctionService.backAfterConfirm();
    } else {
      this.baseFunctionService.back();
    }
  }

  addFileToAttachment(prevItem: FileModel): void {
    this.baseFunctionService.addFileToAttachment(prevItem);
  }

  addFilesToAttachment(prevItems: FileModel[]): void {
    this.baseFunctionService.addFilesToAttachment(prevItems);
  }
}
